import { RNA_OPTIONS } from './constants';

const antisenseMapping = {
  A: 'U',
  a: 'U',
  C: 'G',
  c: 'G',
  U: 'A',
  u: 'A',
  G: 'C',
  g: 'C',
};

export const getAntiseseSequence = (newSenseValue) => {
  let value = '';

  for (let i = 0; i < newSenseValue.length; i += 1) {
    const antisenseChar = antisenseMapping[newSenseValue[i]];

    value = (antisenseChar || '') + value;
  }

  return value;
};

export const isAddToCartAvailable = (formData) => {
  const hasError = !!(
    Object.keys(formData).find((fieldName) => !formData[fieldName].isValid)
  );

  return !hasError;
};

export const validateSenseSequence = (value, sequenceValue) => {
  let sequenceValid = false;

  if (value === RNA_OPTIONS.SI_RNA) {
    if (sequenceValue?.length >= 10 &&
          sequenceValue?.length <= 50) {
      sequenceValid = true;
    }
  } else if (value === RNA_OPTIONS.STEALTH_RNAI) {
    if (sequenceValue?.length === 25) {
      sequenceValid = true;
    }
  }

  return sequenceValid;
};
